var _path;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgAddCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.78595 3.28597C5.81112 1.2608 8.81643 0.810024 11.2779 1.9375L11.8332 0.725277C8.88156 -0.626689 5.27498 -0.0886776 2.84315 2.34316C-0.281049 5.46735 -0.281049 10.5327 2.84315 13.6569L3.78595 12.7141C1.18246 10.1106 1.18246 5.88946 3.78595 3.28597ZM13.214 3.28597C15.8175 5.88946 15.8175 10.1106 13.214 12.7141C11.1889 14.7392 8.18357 15.19 5.72207 14.0625L5.16682 15.2747C8.11844 16.6267 11.725 16.0887 14.1569 13.6569C17.2811 10.5327 17.2811 5.46735 14.1569 2.34316L13.214 3.28597ZM7.83333 5.33337C7.83333 4.96518 8.13181 4.66671 8.5 4.66671C8.86819 4.66671 9.16667 4.96518 9.16667 5.33337V7.33337H11.1667C11.5349 7.33337 11.8333 7.63185 11.8333 8.00004C11.8333 8.36823 11.5349 8.66671 11.1667 8.66671H9.16667V10.6667C9.16667 11.0349 8.86819 11.3334 8.5 11.3334C8.13181 11.3334 7.83333 11.0349 7.83333 10.6667V8.66671H5.83333C5.46514 8.66671 5.16667 8.36823 5.16667 8.00004C5.16667 7.63185 5.46514 7.33337 5.83333 7.33337H7.83333V5.33337Z",
    fill: "#55489E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircle);
export default __webpack_public_path__ + "static/media/add-circle.75088eaa.svg";
export { ForwardRef as ReactComponent };